import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Event from "./pages/Event";
import { UserAuth } from "./lib/authContext";

const AppRoutes = () => {
  const { userData } = UserAuth();

  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/events/:event_id" element={<Event />} />
    </Routes>
  );
};

export default AppRoutes;
